export { default as NavBar } from "./NavBar";
export { default as Layout } from "./Layout";
export { default as CountrycodeSelect } from "./CountrycodeSelect";
export { default as ConfirmationModal } from "./ConfirmationModal";
export { default as TaskCompletePopup } from "./TaskCompletePopup";
export { default as FilterModal } from "./FilterModal";
export { default as BrokerageServiceConversionModal } from "./BrokerageServiceConversionModal";
export { default as TailwindToaster } from "./TailwindToaster";
export { default as Pagination } from "./Pagination";
export { default as CommandPalette } from "./CommandPalette";
export { default as SideBar } from "./SideBar";
export { default as GmapsComponent } from "./Gmaps";
export { default as PropertyThumbnail } from "./PropertyThumbnail";
export { default as ExportToPDF } from "./ExportToPDF";
export { default as PIFBody } from "./PIFBody";
export { default as PropertyImageOverlay } from "./PropertyImageOverlay";
export { default as Assignee } from "./Assignee";
export { default as ChangeAssigneeOverlay } from "./ChangeAssigneeOverlay";
export { default as RichTextEditor } from "./RichTextEditor";
export { default as MeetingsList } from "./MeetingsList";
export { default as MeetingItem } from "./MeetingItem";
export { default as Hammenu } from "./Hammenu";
export { default as FillMOM } from "./FillMOM";
export { default as PropertyTagging } from "./PropertyTagging";

export const numberToINR = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(value);
